import React from 'react';
import { formatReleaseDate } from '../../utils/releaseDate';

interface ReleaseStatusInfoProps {
  car: {
    releasedAt?: string | null;
    releaseNote?: string | null;
    releasedBy?: { fullName?: string | null } | null;
    releaseStatus?: 'TOTAL' | 'PARCIAL' | 'PENDENTE';
    esteirasLiberadas?: Array<{
      esteiraId: string;
      nome: string;
      cor?: string;
      releasedAt?: string;
      releasedBy?: { id: string; fullName: string } | null;
    }>;
  };
}

/** Item "Liberação Administrativa" para os grids de informações dos modais de ações. */
const ReleaseStatusInfo: React.FC<ReleaseStatusInfoProps> = ({ car }) => {
  const getReleaseContent = () => {
    // Se não vier o releaseStatus (payload antigo em cache), faz o fallback baseado no releasedAt
    const status = car.releaseStatus || (car.releasedAt ? 'TOTAL' : 'PENDENTE');

    if (status === 'TOTAL') {
      return (
        <span style={{ color: 'var(--tema-texto-verde, #137333)', fontWeight: 600 }}>
          Liberado em {formatReleaseDate(car.releasedAt)} por {car.releasedBy?.fullName || '-'}
          {car.releaseNote && ` (${car.releaseNote})`}
        </span>
      );
    }

    if (status === 'PARCIAL') {
      const names = (car.esteirasLiberadas || []).map((e) => e.nome).join(', ');
      return (
        <span style={{ color: 'var(--tema-texto-laranja, #b45309)', fontWeight: 600 }}>
          Liberação parcial: {names || '-'}
          {car.releaseNote && ` (${car.releaseNote})`}
        </span>
      );
    }

    return (
      <span style={{ color: 'var(--tema-texto-2, #5f6368)', fontWeight: 500 }}>Pendente</span>
    );
  };

  return (
    <div className="info-item" style={{ gridColumn: 'span 2' }}>
      <span className="info-label">Liberação Administrativa</span>
      <span className="info-value">{getReleaseContent()}</span>
    </div>
  );
};

export default ReleaseStatusInfo;
